import AutoInlineAdProcessor from './autoInlineAdProcessor';
import ManualInlineAdProcessor from './manualInlineAdProcessor';
import { type Article } from '~/types/article';
import useSkipModules from '~/composables/useSkipModules';

/**
 * InlineAdProcessor — Orchestrator
 *
 * Delegates to:
 *  - ManualInlineAdProcessor  when article.metadata.manuallyPlacedAds === true
 *  - AutoInlineAdProcessor    otherwise (default)
 *
 * Skips all inline ad placement when:
 *  - The AD module is skipped via URL param
 *  - article.metadata.removeInlineAds === true
 */
export default class InlineAdProcessor {
  private readonly articleAdConfig: any;

  constructor (articleAdConfig: any) {
    this.articleAdConfig = articleAdConfig;
  }

  process (article: Article): void {
    const route = useRoute();
    if (useSkipModules(route).skipModule(useSkipModules(route).moduleNames.AD)) { return; }

    // Never place inline ads when the article explicitly disables them
    if (article?.metadata?.removeInlineAds === true) { return; }

    if (article?.metadata?.manuallyPlacedAds === true) {
      new ManualInlineAdProcessor(this.articleAdConfig).process(article);
    } else {
      new AutoInlineAdProcessor(this.articleAdConfig).process(article);
    }
  }
}
